import { useNavigate } from 'react-router-dom';
import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function SemPermissao() {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4 text-center px-4">
      <ShieldX className="h-16 w-16 text-destructive" />
      <h1 className="text-2xl font-bold">Acesso não permitido</h1>
      <p className="text-muted-foreground max-w-sm">
        Você não tem permissão para acessar esta página.
        Entre em contato com o administrador do sistema.
      </p>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => navigate(-1)}>Voltar</Button>
        <Button onClick={() => navigate('/')}>Ir para o Dashboard</Button>
      </div>
    </div>
  );
}
